/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OAuthProvider } from './OAuthProvider';
import {
    OAuthProviderFromJSON,
    OAuthProviderFromJSONTyped,
    OAuthProviderToJSON,
    OAuthProviderToJSONTyped,
} from './OAuthProvider';

/**
 * 
 * @export
 * @interface OIDCTokensInfo
 */
export interface OIDCTokensInfo {
    /**
     * 
     * @type {string}
     * @memberof OIDCTokensInfo
     */
    authn_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OIDCTokensInfo
     */
    token_types: Array<string>;
    /**
     * 
     * @type {OAuthProvider}
     * @memberof OIDCTokensInfo
     */
    provider: OAuthProvider;
    /**
     * 
     * @type {string}
     * @memberof OIDCTokensInfo
     */
    client_id: string;
    /**
     * Groups the user belongs to in the OIDC provider
     * @type {Array<string>}
     * @memberof OIDCTokensInfo
     */
    oidc_groups?: Array<string>;
}



/**
 * Check if a given object implements the OIDCTokensInfo interface.
 */
export function instanceOfOIDCTokensInfo(value: object): value is OIDCTokensInfo {
    if (!('authn_id' in value) || value['authn_id'] === undefined) return false;
    if (!('token_types' in value) || value['token_types'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('client_id' in value) || value['client_id'] === undefined) return false;
    return true;
}

export function OIDCTokensInfoFromJSON(json: any): OIDCTokensInfo {
    return OIDCTokensInfoFromJSONTyped(json, false);
}

export function OIDCTokensInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OIDCTokensInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'authn_id': json['authn_id'],
        'token_types': json['token_types'],
        'provider': OAuthProviderFromJSON(json['provider']),
        'client_id': json['client_id'],
        'oidc_groups': json['oidc_groups'] == null ? undefined : json['oidc_groups'],
    };
}

export function OIDCTokensInfoToJSON(json: any): OIDCTokensInfo {
    return OIDCTokensInfoToJSONTyped(json, false);
}

export function OIDCTokensInfoToJSONTyped(value?: OIDCTokensInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'authn_id': value['authn_id'],
        'token_types': value['token_types'],
        'provider': OAuthProviderToJSON(value['provider']),
        'client_id': value['client_id'],
        'oidc_groups': value['oidc_groups'],
    };
}

